/*--------------------------------------------------------------
# Custom scripts for Form block
--------------------------------------------------------------*/

// Wait for the entire DOM content to be loaded before running the script
document.addEventListener("DOMContentLoaded", function() {
    
    // Select all form elements within elements with class 'form-block'
    const formBlocks = document.querySelectorAll(".form-block form");

    // Iterate over each form found
    formBlocks.forEach(form => {
        // Find the element with ID that starts with 'gform_fields_'
        const gformFieldContainer = form.querySelector("[id^='gform_fields_']");
        if (!gformFieldContainer) return; // If no such element is found, skip this form

        // Get an array of all child elements within the found gform field container
        const formElements = Array.from(gformFieldContainer.children);
        let customColumnDiv = null; // Variable to hold the custom column div
        let column1Wrap = null; // Variable to hold the column-1-wrap div
        let column2Wrap = null; // Variable to hold the column-2-wrap div

        // Iterate over each form element
        formElements.forEach(element => {
            // Check if the element has the class 'column-1'
            if (element.classList.contains("column-1")) {
                // If customColumnDiv has not been created yet
                if (!customColumnDiv) {
                    customColumnDiv = document.createElement("div");
                    customColumnDiv.classList.add("custom-gf-column");
                    // Insert the customColumnDiv before the current element in the DOM
                    gformFieldContainer.insertBefore(customColumnDiv, element);

                    // Create and append the column-1-wrap div
                    column1Wrap = document.createElement("div");
                    column1Wrap.classList.add("column-1-wrap");
                    customColumnDiv.appendChild(column1Wrap);

                    // Create and append the column-2-wrap div
                    column2Wrap = document.createElement("div");
                    column2Wrap.classList.add("column-2-wrap");
                    customColumnDiv.appendChild(column2Wrap);
                }

                // Append the current element to the column1Wrap div
                column1Wrap.appendChild(element);
            } else if (element.classList.contains("column-2")) {
                // Check if customColumnDiv exists
                if (customColumnDiv) {
                    // Append the current element to the column2Wrap div
                    column2Wrap.appendChild(element);
                }
            } else {
                // For elements that do not belong to column-1 or column-2
                if (customColumnDiv) {
                    // Insert the customColumnDiv before the current element in the DOM
                    gformFieldContainer.insertBefore(customColumnDiv, element);
                    // Reset customColumnDiv and column wrappers
                    customColumnDiv = null;
                    column1Wrap = null;
                    column2Wrap = null;
                }
            }
        });

        // Ensure any remaining open custom column div is appended at the end of the form
        if (customColumnDiv) {
            gformFieldContainer.appendChild(customColumnDiv);
        }
    });
});
